import React from "react";

export function PortalFilterField({ label, children, className = "" }) {
  return (
    <div className={["portal-field", className].filter(Boolean).join(" ")}>
      {label ? <label className="portal-field__label">{label}</label> : null}
      {children}
    </div>
  );
}

export function PortalFilterBar({ children, className = "" }) {
  return <div className={["portal-filter-bar", className].filter(Boolean).join(" ")}>{children}</div>;
}

const BTN_VARIANTS = {
  primary: "portal-btn portal-btn--primary",
  secondary: "portal-btn portal-btn--ghost",
  ghost: "portal-btn portal-btn--ghost",
  danger: "portal-btn portal-btn--danger",
};

export function PortalButton({ variant = "ghost", className = "", type = "button", ...props }) {
  return (
    <button
      type={type}
      className={[BTN_VARIANTS[variant] || BTN_VARIANTS.ghost, className].filter(Boolean).join(" ")}
      {...props}
    />
  );
}

export function PortalAlert({ children, variant = "error", className = "" }) {
  return (
    <div className={["portal-alert", `portal-alert--${variant}`, className].filter(Boolean).join(" ")}>
      {children}
    </div>
  );
}

export function portalInputClass(hasError = false) {
  return ["portal-input", hasError ? "portal-input--error" : ""].filter(Boolean).join(" ");
}
